<template>
    <span>{{ computedValue }}%</span>
</template>
<script>
    //import utils from "../utils/units";
    import * as common from "../utils/common";
    import * as brewcalc from "brewcalc";

    export default {
        name: "live-abv-label",
        props: ['og', 'fg'],
        computed: {
            computedValue() {
                return common.round(brewcalc.estABVrealExtract(this.og, this.fg), 1).toFixed(1);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/LiveAbvLabel.vue